// gpt
import { add_onepage_slide_general } from "../util/gpt_onepage_general";

// Pub
import { gptPubIds } from "@/service/wd_pubsub_config.js";
import { publish } from "@/service/wd_pubsub.js";

// 生成完整PPT
export async function createOnepagePPT(responseMessage) {
  let indexSymbol = responseMessage.indexOf("#");
  const generatedText = indexSymbol != -1 ? responseMessage.substr(indexSymbol) : responseMessage;
  // 显示文本去掉Markdown的符号
  if (indexSymbol != -1) {
    await add_onepage_slide_general(generatedText);
  } else {
    // 普通GPT的答复，直接将文本显示为一条消息
    publish(gptPubIds.pubId_Local_Addin_SystemLog, responseMessage.replace(/\n/g, "<br />"));
  }
  publish(gptPubIds.pubId_Local_Gpt_Processing_Success, "");
}
